'use es6';

import ImmutableModel from 'DesignData/models/ImmutableModel';
import { PIXELS } from 'DesignData/enums/SizeUnits';
import { createOptimizedOmit } from 'DesignData/lib/object';
const omit = createOptimizedOmit(['units']);
/**
 * Wrapper class of PaneSize data.
 * To be used in Pane Components.
 */

class PaneSize extends ImmutableModel {
  /**
   * @constructor
   */
  constructor(props) {
    const _props = props.units ? props : omit(props);

    return super(_props);
  }

}

PaneSize.DEFAULT_FIELDS = {
  units: PIXELS
};
export default PaneSize;